import type { SignupTrackingPort } from '@cencosud-cencommerce/paris-login';

import { trackEvent } from './brazeClient';

export class BrazeSignupTrackingAdapter implements SignupTrackingPort {
  signupStarted() {
    trackEvent('signup_started');
  }

  signupCompleted() {
    trackEvent('signup_completed');
  }
}
